(() => {
  if (window.__miarettiCartRecommendationImageFixV521) return;
  window.__miarettiCartRecommendationImageFixV521 = true;

  const updateRecommendationImage = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const select = target.closest('[data-cart-recommendation-select]');
    if (!select) return;

    const card = select.closest('[data-cart-recommendation-card]');
    const option = select.options?.[select.selectedIndex];
    const image = card?.querySelector('[data-cart-recommendation-image]');
    const imageUrl = option?.dataset?.image;

    if (!image || !imageUrl) return;

    // The select already submits the correct variant ID. This patch only
    // synchronizes the visible thumbnail with that selected variant.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
    image.setAttribute('src', imageUrl);
  };

  // Capture phase keeps this reliable even if another theme component stops
  // the event later in the bubbling phase.
  document.addEventListener('change', updateRecommendationImage, true);
  document.addEventListener('input', updateRecommendationImage, true);
})();
